import React from "react";
import { FieldValues, Path, UseFormRegister } from "react-hook-form";

type InputProps = {
  displayLabel?: string;
  placeholder?: string;
  inputName?: string;
  classNames?: string;
  bgColor: string;
  label: Path<FieldValues>;
  register: UseFormRegister<FieldValues>;
  required?: boolean;
  minLength?: number;
  maxLength?: number;
};

type TextInputProps = InputProps & {
  type: "text";
};

type TextAreaProps = InputProps & {
  type: "textarea";
  rows: number;
};

type Props = TextInputProps | TextAreaProps;

/**
 * Text input with label built inside
 * @param props `{displayLabel, placeholder, inputName}`,
 * `displayLabel` is name of the label above the input,
 * `placeholderName` is the placeholder of the text input and
 * `inputName` is the label's htmlFor and input's name and id attribute
 * @returns JSX.Element
 */
const TextFieldLabel = (props: Props) => {
  const {
    type,
    displayLabel,
    label,
    placeholder,
    bgColor,
    classNames,
    register,
    required,
  } = props;

  return (
    <div
      className={`relative rounded-md border border-slate-700 px-3 py-2 focus-within:border-slate-600 focus-within:ring-1 focus-within:ring-slate-600 
      ${classNames ? classNames : ""}`}
    >
      <label
        className={`absolute -top-2 left-2 -mt-px inline-block px-2 text-slate-300 ${bgColor}`}
      >
        {displayLabel}
      </label>

      {type === "text" ? (
        <input
          type="text"
          className="border-0 px-0 py-1 text-slate-300 focus:ring-0"
          placeholder={placeholder}
          {...register(label, {
            required: required,
            minLength: props?.minLength,
            maxLength: props?.maxLength,
          })}
        />
      ) : null}

      {type === "textarea" ? (
        <textarea
          className="border-0 px-0 py-3 text-slate-300 focus:ring-0"
          placeholder={placeholder}
          rows={props.rows}
          {...register(label, { required })}
        />
      ) : null}
    </div>
  );
};

export default TextFieldLabel;
